<template>
  <div v-if="images.length" class="gmf-gallery">
    <div
      class="gmf-gallery-container"
      ref="container"
      @touchend.prevent="touchend"
      @touchstart.prevent="touchstart"
      @touchmove.prevent="touchmove"

      @mouseup.passive="touchend"
      @mouseleave.passive="endactions"
      @mousedown.passive="touchstart"
      @mousemove.passive="touchmove"

      :style="{
        cursor: isZoomed ? 'move' : null,
      }"
      >
        <div class="gmf-gallery-scroller" :style="{ transform: 'translateX(' + left + ')' }">
          <div v-for="(image, i) in images" :key="image.url" class="gmf-gallery-image"
          :style="{
            'background-image': 'url(' + (image.largeUrl || image.url) + ')',
            transform: i == index ? 'translate(' + pan.x + 'px, ' + pan.y + 'px) scale(' + zoom + ')' : null,
            transition: action !== 'none' ? 'none' : null,
          }"
        ></div>
      </div>

      <div class="gmf-gallery-left" @touchstart.stop.prevent="move(-1)" @click="move(-1)" v-if="index > 0"></div>
      <div class="gmf-gallery-right" @touchstart.stop.prevent="move(1)" @click="move(1)" v-if="index < images.length - 1"></div>
      <div class="gmf-gallery-zoom-buttons">
        <div class="gmf-gallery-zoom-in" :class="{ 'gmf-disabled': zoom >= maxZoom }" @touchstart.stop.prevent="zoomIn" @click.stop.prevent="zoomIn" />
        <div class="gmf-gallery-zoom-out" :class="{ 'gmf-disabled': zoom <= minZoom }" @touchstart.stop.prevent="zoomOut" @click.stop.prevent="zoomOut" />
      </div>
    </div>
    <GalleryFooter :images="images" :index="index" @update:index="selectImage" />
  </div>
</template>

<style>
.gmf-gallery {
  max-width: 100%;
  max-height: 84vh;
  display: flex;
  flex-direction: column;
  width: 900px;
  height: 750px;
}
.gmf-gallery-container {
  margin-bottom: 16px;
  overflow: hidden;
  flex-grow: 1;
  position: relative;
  margin-left: -16px;
  margin-right: -16px;
  touch-action: none;
}
.gmf-gallery-thumbnails, .gmf-context .gmf-gallery-thumbnails {
  overflow: hidden;
  text-align: center;
  line-height: 0;
  position: relative;
  margin: calc(0px - var(--gmf-modal-padding));
  margin-top: 0;
  background: var(--gmf-col-lightgray);
  border-radius: 0 0 var(--gmf-modal-rounding) var(--gmf-modal-rounding);
  overflow: hidden;
  padding: 8px 18px;
}
.gmf-gallery-thumbnail-anchor {
  white-space: nowrap;
  text-align: left;
  will-change: transform;
  transition: transform 0.2s ease-out;
}
.gmf-gallery .gmf-image-thumbnail-wrapper {
  margin: 8px;
  cursor: pointer;
  float: none;
  display: inline-block;
  border: none;
  box-shadow: 0px 0px 5px 1px rgb(0 0 0 / 5%);
  padding: 6px;
  border-bottom: 3px solid white;
  padding-bottom: 3px;
  transition: border-color 0.15s ease-out;
}
.gmf-gallery .gmf-image-thumbnail {
  background-repeat: no-repeat;
  background-size: contain;
}
.gmf-gallery .gmf-image-thumbnail-wrapper.gmf-active {
  border-color: var(--gmf-highlight-col);
}

.gmf-gallery-zoom-in, .gmf-gallery-zoom-out {
  cursor: pointer;
  background-color: var(--gmf-col-lightgray);
  border-radius: var(--gmf-rounding);

  opacity: 0.9;

  width: 32px;
  height: 32px;

  background-size: 60%;
  background-position: center;
  background-repeat: no-repeat;
}

.gmf-gallery-zoom-buttons {
  position: absolute;
  right: 4px;
  bottom: 16px;
}
.gmf-gallery-zoom-in {
  margin-bottom: 8px;
  background-image: var(--gmf-icons-zoom-in);
}
.gmf-gallery-zoom-out {
  background-image: var(--gmf-icons-zoom-out);
}
.gmf-gallery-zoom-in.gmf-disabled, .gmf-gallery-zoom-out.gmf-disabled {
  opacity: 0.5;
  cursor: default;
}

.gmf-gallery-left, .gmf-gallery-right {
  cursor: pointer;
  position: absolute;
  background: var(--gmf-col-lightgray);
  border-radius: var(--gmf-rounding);
  top: 50%;
  width: 32px;
  height: 60px;
  transform: translateY(-50%);

  background-image: var(--gmf-icon-chevron-right);
  background-repeat: no-repeat;
  background-size: 35%;
  background-position: center;
  transform-origin: center;
  opacity: 0.9;
}
.gmf-gallery-left {
  left: 4px;
  transform: translateY(-50%) scaleX(-1);
}
.gmf-gallery-right {
  right: 4px;
}

.gmf-gallery-scroller {
  position: absolute;
  transition: transform 0.2s;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  will-change: transform;
}
.gmf-gallery-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 100%;
  display: inline-block;
  transform-origin: center;
  will-change: transform;
  transition: transform 0.1s ease-out;
}


.gmf-gallery-thumbnail-nav {
  top: 4px;
  bottom: 4px;
  background: var(--gmf-col-lightgray);
  width: 40px;
  position: absolute;
  cursor: pointer;
  transition: opacity 0.1s ease-out;
  box-shadow: -8px 0 10px -9px rgb(0 0 0 / 20%);
  border-left: 1px solid var(--gmf-col-gray);
  background-image: var(--gmf-icon-chevron-right);
  background-repeat: no-repeat;
  background-size: 35%;
  background-position: center;
  transform-origin: center;
}
.gmf-gallery-thumbnail-nav.gmf-disabled {
  opacity: 0;
  pointer-events: none;
}

.gmf-gallery-thumbnail-nav-left {
  left: 0;
  transform: scale(-1,1);
}
.gmf-gallery-thumbnail-nav-right {
  right: 0;
}

@media (max-width: 480px) {
  .gmf-gallery .gmf-image-thumbnail-wrapper {
    width: 64px;
    height: 64px;
  }
}
@media (max-height: 480px) {
  .gmf-gallery .gmf-image-thumbnail-wrapper {
    width: 48px;
    height: 48px;
  }
}
</style>

<script>
// @TODO use normal url until we've scrolled to an image, then switch to largeUrl
import GalleryFooter from './GalleryFooter';

export default {
  name: 'ImageGallery',
  components: {
    GalleryFooter,
  },
  inject: ['images', 'initialIndex'],
  data () {
    return {
      index: this.initialIndex,

      // Touch zooming stuff
      minZoom: 1,
      maxZoom: 4,

      action: 'none',
      zoom: 1,

      prevZoom: 1,
      previousTouchInfo: null,

      pan: {x: 0, y: 0},
      prevPan: {x: 0, y: 0},

      zoomOriginOffset: {x: 0, y: 0},
    };
  },
  computed: {
    left () {
      return (this.index * -100).toFixed(0) + '%';
    },
    selectedImage () {
      return this.images[this.index];
    },
    isZoomed () {
      return this.zoom > 1.01;
    },
  },
  methods: {
    zoomIn () {
      this.prevZoom = this.zoom;
      this.zoom += 0.33 * this.zoom;
      this.capZoom();

      this.correctForZoomOrigin(this.zoom, this.prevZoom, this.pan);

      this.capPan();
    },
    zoomOut () {
      this.prevZoom = this.zoom;
      this.zoom -= 0.33 * this.zoom;
      this.capZoom();

      this.correctForZoomOrigin(this.zoom, this.prevZoom, this.pan);

      this.capPan();
    },
    correctForZoomOrigin (newZoom, prevZoom, prevPan, zoomOriginOffset) {
      this.pan.x = (newZoom / prevZoom) * prevPan.x;
      this.pan.y = (newZoom / prevZoom) * prevPan.y;

      if (zoomOriginOffset) {
        this.pan.x -= ((newZoom / prevZoom) - 1) * zoomOriginOffset.x;
        this.pan.y -= ((newZoom / prevZoom) - 1) * zoomOriginOffset.y;
      }
    },
    capZoom () {
      if (this.zoom < this.minZoom) {
        this.zoom = this.minZoom;
      }
      if (this.zoom > this.maxZoom) {
        this.zoom = this.maxZoom;
      }
    },
    capPan () {
      // @TODO if we use the actual dimensions of the image (inside the container), use that instead for better capping.
      const { width, height } = this.$refs.container.getBoundingClientRect();

      const maxX = width * (this.zoom - 1) * .5;
      const maxY = height * (this.zoom - 1) * .5;

      if (this.pan.x < -maxX) {
        this.pan.x = -maxX;
      } else if (this.pan.x > maxX) {
        this.pan.x = maxX;
      }

      if (this.pan.y < -maxY) {
        this.pan.y = -maxY;
      } else if (this.pan.y > maxY) {
        this.pan.y = maxY;
      }
    },
    resetPanAndZoom () {
      this.previousTouchInfo = null;
      this.action = 'none';
      this.zoom = 1;
      this.pan = {x: 0, y: 0};
    },
    startzoom (evt) {
      this.action = 'zoom';
      this.previousTouchInfo = evt.touches;
      this.prevZoom = this.zoom;

      Object.assign(this.prevPan, this.pan);

      // Zoom origin offset, ensuring the zooming is focused between the two fingers of the touch zoom
      const [ t0, t1 ] = evt.touches;

      const container = this.$refs.container.getBoundingClientRect();
      this.zoomOriginOffset = {
        x: (t0.clientX + t1.clientX) / 2 - container.x - container.width / 2,
        y: (t0.clientY + t1.clientY) / 2 - container.y - container.height / 2,
      };
    },
    endactions () {
      this.action = 'none';
      this.previousTouchInfo = null;
      if (this.zoom < 1.1) {
        this.zoom = 1;
      }
    },
    getTouchesOrMouseFromEvt (evt) {
      if (evt.touches && evt.touches.length > 0) {
        return evt.touches;
      }
      return [evt];
    },
    touchstart (evt) {
      const touches = this.getTouchesOrMouseFromEvt(evt);
      if (touches.length == 1 && this.isZoomed) {
        this.previousTouchInfo = touches;
        this.action = 'pan';
        Object.assign(this.prevPan, this.pan);
      } else if (touches.length >= 2 && this.action !== 'zoom') {
        this.startzoom(evt);
      }
    },
    touchend (evt) {
      const touches = this.getTouchesOrMouseFromEvt(evt);
      if (touches.length < 2) {
        this.endactions();
      }
    },
    touchmove (evt) {
      if (! this.previousTouchInfo) {
        return;
      }
      const touches = this.getTouchesOrMouseFromEvt(evt);

      if (this.action === 'pan') {
        const [oldTouch] = this.previousTouchInfo;
        const [newTouch] = touches;

        this.pan.x = this.prevPan.x + newTouch.clientX - oldTouch.clientX;
        this.pan.y = this.prevPan.y + newTouch.clientY - oldTouch.clientY;

        this.capPan();

        // @TODO limit pan
      }

      if (this.action === 'zoom') {
        const [ot1, ot2] = this.previousTouchInfo;
        const [nt1, nt2] = touches;

        const odistx = Math.abs(ot1.clientX - ot2.clientX);
        const odisty = Math.abs(ot1.clientY - ot2.clientY);
        const ndistx = Math.abs(nt1.clientX - nt2.clientX);
        const ndisty = Math.abs(nt1.clientY - nt2.clientY);

        const prevDist = Math.sqrt(odistx*odistx+odisty*odisty);
        const newDist = Math.sqrt(ndistx*ndistx+ndisty*ndisty);

        this.zoom = (newDist / prevDist) * this.prevZoom;

        this.capZoom();

        this.correctForZoomOrigin(this.zoom, this.prevZoom, this.prevPan, this.zoomOriginOffset);

        this.capPan();
      }
    },
    move (distance) {
      this.index += distance;
      while (this.index < 0) {
        this.index += this.images.length;
      }
      while (this.index >= this.images.length) {
        this.index -= this.images.length;
      }
      this.resetPanAndZoom();
    },
    selectImage (index) {
      this.index = index;
      this.resetPanAndZoom();
    },
  },
};
</script>
